import React from 'react';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import { TrendingUp, Target, BarChart3 } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ComparisonMode } from '@/types/filters';

interface ComparisonToggleProps {
  value: ComparisonMode;
  onChange: (value: ComparisonMode) => void;
  className?: string;
}

export const ComparisonToggle: React.FC<ComparisonToggleProps> = ({
  value,
  onChange,
  className
}) => {
  return (
    <ToggleGroup 
      type="single" 
      value={value} 
      onValueChange={(v) => v && onChange(v as ComparisonMode)}
      className={cn("bg-white border border-figma-primary/20 rounded-figma-button p-1", className)}
    >
      <ToggleGroupItem 
        value="none" 
        aria-label="Sin comparación"
        className="text-xs px-3 py-2 rounded-figma-button data-[state=on]:bg-figma-primary data-[state=on]:text-white hover:bg-figma-primary/10"
      >
        Actual
      </ToggleGroupItem>
      <ToggleGroupItem 
        value="previous-period" 
        aria-label="Período anterior"
        className="text-xs px-3 py-2 rounded-figma-button data-[state=on]:bg-figma-primary data-[state=on]:text-white hover:bg-figma-primary/10"
      >
        <TrendingUp className="h-3 w-3 mr-1" />
        vs Anterior
      </ToggleGroupItem>
      <ToggleGroupItem 
        value="target" 
        aria-label="Objetivo"
        className="text-xs px-3 py-2 rounded-figma-button data-[state=on]:bg-figma-primary data-[state=on]:text-white hover:bg-figma-primary/10"
      >
        <Target className="h-3 w-3 mr-1" />
        vs Objetivo
      </ToggleGroupItem>
      <ToggleGroupItem 
        value="average" 
        aria-label="Promedio"
        className="text-xs px-3 py-2 rounded-figma-button data-[state=on]:bg-figma-primary data-[state=on]:text-white hover:bg-figma-primary/10"
      >
        <BarChart3 className="h-3 w-3 mr-1" />
        vs Promedio
      </ToggleGroupItem>
    </ToggleGroup>
  );
};